import * as angular from 'angular';

import { ComponentDefinition, Log } from '../../../models';

class LogsByApplicationStateController implements angular.IComponentController {
    readonly isLoading: boolean;
    readonly logs: Log[];

    static $inject = [];
}

export const wtLogsByApplicationState: ComponentDefinition = {
    componentId: 'wtLogsByApplicationState',
    controller: LogsByApplicationStateController,
    controllerAs: 'vm',
    template: require('./logsByApplicationState.component.html'),
    bindings: {
        isLoading: '<',
        logs: '<'
    }
};
